import type {
  IAdapterConfig,
  MiddlewareConfigClass
} from '@care-portals/api-interfaces';

const config = {
  tmc: {
    label: 'TMC Pharmacy',
    functions: {
      CreateOrder: {
        middlewareHandler: 'tmc',
        version: 2,
        label: 'Create Order',
        pipelines: ['order'],
        passPayload: true,
        params: []
      },
      /**
       * TMC has no webhooks, so status only advances when this is called. Also invoked on a
       * schedule by the TMC status-polling cron (apps/middleware/src/tmc/TMC_STATUS_POLLING.md);
       * this config entry exists so it can also be run manually from a Workflow.
       */
      RetrieveOrder: {
        middlewareHandler: 'tmc',
        version: 2,
        label: 'Retrieve Order',
        pipelines: ['order'],
        passPayload: true,
        params: []
      }
    }
  }
} as const;

export const TmcConfig: IAdapterConfig = {
  ...config
} as unknown as IAdapterConfig;

export type TmcFunctionConfiguration = MiddlewareConfigClass<
  typeof config.tmc.functions
>;
